import React, { useState, useEffect } from "react";
import DashboardLayout from "../DashboardLayout";
import EmployeesList from "./employeeList";
import Loading from "../../Components/Loading";
import { useAppContext } from "../../services/context";
import {
  fetchDepartments,
  fetchDesignations,
  fetchEmployees,
  fetchRoles,
} from "./helpers";

const Employees = ({ navigate }) => {
  const { state, setState } = useAppContext();
  const { permissions } = state;
  const [employees, setEmployees] = useState([]);
  const [pagination, setPagination] = useState({});
  const [departments, setDepartments] = useState([]);
  const [designations, setDesignations] = useState([]);
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [granted, setGranted] = useState([]);

  const extractPermissions = () => {
    const perms = permissions?.filter((f) => f.module === "Employees");
    if (perms) {
      setGranted(perms);
    }
  };

  useEffect(() => {
    extractPermissions();
    fetchEmployees(setEmployees, pagination, setPagination, navigate);
    setLoading(false);
    fetchDesignations(setDesignations, navigate);
    fetchDepartments(setDepartments, navigate);
    fetchRoles(setRoles, navigate);
    return () => {
      setState((prev) => ({ ...prev, employee: null }));
    };
  }, []);

  return (
    <DashboardLayout>
      <div data-testid="employees">
        <div className="row">
          <div className="col-12 mb-3">
            <div className="page-title-box d-sm-flex">
              <div className="page-title-right">
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item" data-testid="dashboard">
                    <a>Dashboard</a>
                  </li>
                  <li
                    className="breadcrumb-item active"
                    style={{ color: "#8b8b8cbf" }}
                    data-testid="employees"
                  >
                    Employees
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        {loading ? (
          <Loading />
        ) : (
          <EmployeesList
            employees={employees}
            setEmployees={setEmployees}
            departments={departments}
            designations={designations}
            roles={roles}
            pagination={pagination}
            setPagination={setPagination}
            granted={granted}
          />
        )}
      </div>
    </DashboardLayout>
  );
};
export default Employees;
